import $ from 'jquery';

import Config from '../config';
import View from './view';
import i18n from '../i18n';

import { promisify } from '../utils/promisify';
import { ask } from '../utils/popups';





let ifn; i18n.then( i => ifn = i );

export default View.extend( {

    [View.event( 'file:upload' )](type, minSize, maxSize) {
        Backbone.$( '<input type="file" name="file" style="visibility:hidden;height:0;">' )
            .appendTo( document.body )
            .on( 'change', e => { 
                const [binaryFile] = e.target.files;

                if (typeof minSize === 'number' || typeof minSize === 'string' && typeof +minSize === 'number')
                    if (binaryFile.size < minSize)
                        return ask( ifn( 'errors::file is too small', { size: minSize } ),
                            'errors::common notification', 
                            'actions::close' );
                if (typeof maxSize === 'number' || typeof maxSize === 'string' && typeof +maxSize === 'number')
                    if (binaryFile.size > maxSize)
                        return ask( ifn( 'errors::file is too large', { size: maxSize } ),
                            'errors::common notification', 
                            'actions::close' );

                const uploading = upload( binaryFile, type );

                this.trigger( 'file:upload-done', 
                    binaryFile.name, type, uploading, binaryFile );
            } )
            .click();
    },

} );

function upload( binaryFile, type) {
    const data = new FormData(); data.append( 'file', binaryFile );

    const req = promisify( Backbone.$.ajax( {
        url: Config.url( `/files/upload/${type}` ),
        data: data,
        contentType: false,
        processData: false,
        method: 'POST'
    } ) );

    return req.then( response => response.name );
}


// WEBPACK FOOTER //
// ./src/js/view/attachments.controls.js